import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomIconButtonProps {
  Icon: React.ReactNode;
  onClick: () => void;
  fullWidthMobile?: boolean;
  text?: string;
  outlined?: boolean;
  tooltip?: string;
  iconClassName?: string;
}

const CustomIconButton = ({
  Icon,
  onClick,
  fullWidthMobile = false,
  text = "",
  outlined = false,
  tooltip,
  iconClassName,
}: CustomIconButtonProps) => {
  return (
    <div className={tooltip ? styles.tooltipWrapper : undefined}>
      <button
        type="button"
        className={classNames(
          styles.iconButtonContainer,
          fullWidthMobile && styles.fullWidthMobile,
          outlined && styles.outlined,
          iconClassName,
        )}
        onClick={onClick}
      >
        {Icon}
        {fullWidthMobile && (
          <span
            className={classNames(styles.iconButtonText, "md:hidden block")}
          >
            {text}
          </span>
        )}
      </button>
      {tooltip && <span className={styles.tooltipText}>{tooltip}</span>}
    </div>
  );
};

export default CustomIconButton;
